import BolsaFamiliaIndexPage from "@/Pages/BolsaFamilia/index.vue";

export default [
  {
    path: "/bolsa-familia/",
    name: "bolsa-familia",
    component: BolsaFamiliaIndexPage,
  },
];
